import React, { useState } from "react";
import auth from "./auth";
import { useNavigate } from "react-router-dom";
import { db } from "../firebaseConfig";
import { doc, setDoc } from "firebase/firestore";
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  setPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
} from "firebase/auth";

// Import the background and logo images
import back6 from "./back2.png"; // Adjust the path if needed
import logo111 from "./Lego222.png";

const LoginPage = () => {
  const [signingUp, setSigningUp] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState("");
  const [resetStatus, setResetStatus] = useState("");

  const navigate = useNavigate();

  // LOGIN FUNCTION
  const handleLogin = async () => {
    setError("");
    setResetStatus("");
    try {
      const persistence = rememberMe
        ? browserLocalPersistence
        : browserSessionPersistence;
      await setPersistence(auth, persistence);
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/marketplace");
    } catch (err) {
      setError("Login failed. Please check your credentials.");
    }
  };

  // CREATE ACCOUNT FUNCTION
  const handleSignUp = async () => {
    setError("");
    setResetStatus("");

    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;

      const userDoc = doc(db, "users", user.uid);
      await setDoc(userDoc, {
        email: user.email,
        userID: user.uid,
        createdAt: new Date().toISOString(),
        userName: name,
      });

      setName("");
      navigate("/marketplace");
    } catch (err) {
      setError("Could not create account. " + err.message);
    }
  };

  // FORGOT PASSWORD FUNCTION
  const handlePasswordReset = async () => {
    if (!email) {
      setError("Please enter your email above before resetting password.");
      return;
    }
    setError("");
    setResetStatus("");
    try {
      await sendPasswordResetEmail(auth, email);
      setResetStatus("Password reset link sent to: " + email);
    } catch (err) {
      setError("Could not send password reset. " + err.message);
    }
  };

  return (
    <div
      style={{
        backgroundImage: `url(${back6})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "top",
        minHeight: "120vh",
        margin: 0,
        padding: "50px 0",
      }}
    >
      <div
        style={{
          maxWidth: "400px",
          margin: "auto",
          padding: "20px",
          fontFamily: "Arial, sans-serif",
          backgroundColor: "rgba(30, 30, 30, 0.8)",  // Slightly transparent background
          borderRadius: "8px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          marginTop: "50px",
        }}
      >
        {/* LOGO Header */}
        <h1 style={{ textAlign: "center", marginBottom: "10px" }}>
          <img src={logo111} alt="Logo" style={{ height: "60px" }} />
        </h1>

        {/* Page Title */}
        <h2 style={{ textAlign: "center", marginBottom: "20px", color: "white" }}>
          {signingUp ? "Create an Account" : "Login"}
        </h2>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (signingUp) {
              handleSignUp();
            } else {
              handleLogin();
            }
          }}
          style={{ display: "flex", flexDirection: "column", gap: "12px" }}
        >
          {/* Name Input (for account creation only) */}
          {signingUp && (
            <label style={{ color: "white", fontWeight: "bold" }}>
              Name:
              <input
                type="text"
                style={{ width: "95%", padding: "8px", marginTop: "4px" }}
                onChange={(e) => setName(e.target.value)}
                value={name}
                placeholder="Enter your name"
                required
              />
            </label>
          )}

          <label style={{ color: "white", fontWeight: "bold" }}>
            Email:
            <input
              type="email"
              style={{ width: "95%", padding: "8px", marginTop: "4px" }}
              onChange={(e) => setEmail(e.target.value)}
              value={email}
              required
              placeholder="Enter your email"
            />
          </label>

          <label style={{ color: "white", fontWeight: "bold" }}>
            Password:
            <input
              type="password"
              style={{ width: "95%", padding: "8px", marginTop: "4px" }}
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              required
              placeholder="Enter your password"
            />
          </label>

          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              color: "white",
              fontWeight: "bold",
            }}
          >
            <input
              type="checkbox"
              onChange={(e) => setRememberMe(e.target.checked)}
              checked={rememberMe}
            />
            Remember Me
          </label>

          <button
            type="submit"
            style={{
              padding: "10px",
              backgroundColor: "#007bff",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            {signingUp ? "Sign Up" : "Login"}
          </button>
        </form>

        <p style={{ textAlign: "center", margin: "20px 0", color: "#666" }}>
          OR
        </p>

        {/* Toggle between Login and Create Account */}
        {signingUp ? (
          <button
            onClick={() => setSigningUp(false)}
            style={{
              width: "100%",
              padding: "10px",
              backgroundColor: "#28a745",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              fontWeight: "bold",
              marginBottom: "20px",
            }}
          >
            Back to Login
          </button>
        ) : (
          <button
            onClick={() => setSigningUp(true)}
            style={{
              width: "100%",
              padding: "10px",
              backgroundColor: "#28a745",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              fontWeight: "bold",
              marginBottom: "20px",
            }}
          >
            Create New Account
          </button>
        )}

        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <button
            onClick={handlePasswordReset}
            style={{
              background: "none",
              border: "none",
              color: "#00c9ff",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            Forgot Password?
          </button>
        </div>

        {error && (
          <p style={{ color: "red", textAlign: "center" }}>{error}</p>
        )}
        {resetStatus && (
          <div
            style={{
              backgroundColor: "#caf0f8",
              color: "#03045e",
              padding: "8px",
              borderRadius: "4px",
              textAlign: "center",
              marginBottom: "20px",
            }}
          >
            {resetStatus}
          </div>
        )}

        {/* Note at the bottom of the login form */}
        <p
          style={{
            fontSize: "0.9em",
            color: "white",
            textAlign: "center",
            marginTop: "20px",
            lineHeight: "1.5",
            whiteSpace: "pre-wrap",
          }}
        >
     
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
